<template>
    <transition name="fade" mode="out-in">
        <div v-show="show" class="notification" :class="notificationClasses">
            <img :src="notificationIcon" />
            <p>{{ content }}</p>
        </div>
    </transition>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        props: {
            content: { type: String, required: true },
            type: { type: String, default: 'success' },
        },

        data() {
            return {
                show: false,
            }
        },

        computed: {
            loadSuccessIcon: function () {
                return require('../../../src/images/sucess-icon.svg').default
            },
            loadErrorIcon: function () {
                return require('../../../src/images/error-icon.svg').default
            },
            notificationIcon: function () {
                if (this.type === 'error') {
                    return this.loadErrorIcon
                }
                return this.loadSuccessIcon
            },
            notificationClasses: function () {
                return {
                    'notification--error': this.type === 'error',
                }
            },
        },

        methods: {
            showNotification: function () {
                this.show = true
            },

            hideNotification: function () {
                this.show = false
            },
        },

        watch: {
            show: function () {
                this.debouncedHideNotification()
            },
        },

        created: function () {
            this.debouncedHideNotification = debounce(this.hideNotification, 2000)
        },
    }
</script>
